import React from 'react'
import { I18nextProvider } from 'react-i18next'

import { QueryCacheAuthReset } from '../QueryCacheAuthReset/QueryCacheAuthReset'

import { AppProvidersProps } from './AppProviders.types'
import i18n from '@percent/partner-dashboard/i18n/config'
import { ClientContextController } from '@percent/partner-dashboard/context/client/clientContextController/ClientContextController'

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ClientContextController>
      <QueryCacheAuthReset />
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </ClientContextController>
  )
}
